<template>
  <div>
    <Navbar></Navbar>

    <!-- GRADIENT SHOWCASE -->
    <section class="section-hero section-lg" v-if="gradient.color3" id="expanded-gradient"
             :class="[ isExpanded ? 'section-overlay' : '']"
             :style="{ 'background': gradient.gradientType + '(' + gradient.gradientRotation + ',' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }"></section>
    <section class="section-hero section-lg" v-else id="expanded-gradient"
             :class="[ isExpanded ? 'section-overlay' : '']"
             :style="{ 'background': gradient.gradientType + '(' + gradient.gradientRotation + ',' + gradient.color1 + ',' + gradient.color2 + ')' }"></section>

    <div class="container mt-3 mt-lg-5">

      <!-- GRADIENT INPUTS -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="card card-overflow overflow-lg shadow-lg">
            <div class="card-header d-flex flex-wrap justify-content-between align-items-center mt-2">
              <!-- TITLE-->
              <vue-aos animation-class="animate__animated animate__flipInX">
                <div>
                  <p class="overline text-primary mb-1">Generator</p>
                  <h1 class="typography-headline-lg fw-500">Gradient</h1>
                  <p class="subtitle-1 text-muted mb-1">Create beautiful gradients combinations!</p>
                </div>
              </vue-aos>
              <div>
                <button v-if="user.loggedIn" class="btn btn-primary btn-round ripple ripple-dark p-md-3"
                        @click="onSubmit">
                  <i class="material-icons-outlined me-2">save</i>
                  Save gradient
                </button>
                <router-link v-else to="/login" class="text-link text-underline">Sign in to save your gradients!
                </router-link>
              </div>
            </div>
            <div class="card-body mb-0 pb-0">
              <!-- FORM -->
              <form action="#" class="row" @submit.prevent="onSubmit">
                <div class="col-md-12">
                  <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active ripple ripple-primary" id="pills-home-tab" data-bs-toggle="pill"
                              data-bs-target="#pills-colors" type="button" role="tab" aria-controls="pills-colors"
                              aria-selected="true">Colors
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link ripple ripple-primary" id="pills-rotation-tab" data-bs-toggle="pill"
                              data-bs-target="#pills-rotation" type="button" role="tab" aria-controls="pills-rotation"
                              aria-selected="false">Rotation
                      </button>
                    </li>
                  </ul>
                  <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-colors" role="tabpanel"
                         aria-labelledby="pills-colors-tab">
                      <div class="row">
                        <!-- GRADIENT COLOR 1 -->
                        <div class="col-12 col-md-4 mb-3">
                          <div class="mb-3">
                            <label for="input-color-1" class="mb-2">Color 1</label>
                            <div class="d-flex align-items-center">
                              <color-picker v-model="gradient.color1" mode="hex"></color-picker>
                              <input type="text" class="form-control form-big-height ms-2" id="input-color-1"
                                     v-model="gradient.color1">
                            </div>
                          </div>
                        </div>
                        <!-- GRADIENT COLOR 2 -->
                        <div class="col-12 col-md-4 mb-3">
                          <div class="mb-3">
                            <label for="input-color-2" class="mb-2">Color 2</label>
                            <div class="d-flex align-items-center">
                              <color-picker v-model="gradient.color2" mode="hex"></color-picker>
                              <input type="text" class="form-control form-big-height ms-2" id="input-color-2"
                                     v-model="gradient.color2">
                            </div>
                          </div>
                        </div>
                        <!-- GRADIENT COLOR 3 -->
                        <div class="col-12 col-md-4 mb-3">
                          <div class="mb-3">
                            <label for="input-color-3" class="mb-2">Color 3 (Optional)</label>
                            <div class="d-flex align-items-center">
                              <color-picker v-model="gradient.color3" mode="hex"></color-picker>
                              <input type="text" class="form-control form-big-height ms-2" id="input-color-3"
                                     v-model="gradient.color3">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="pills-rotation" role="tabpanel" aria-labelledby="pills-rotation-tab">
                      <div class="row">
                        <!-- GRADIENT TYPE -->
                        <div class="col-12 col-md-4 mb-3">
                          <div class="mb-2">
                            <label for="input-type">Type</label>
                          </div>
                          <div class="">
                            <div class="btn-group" id="input-type" role="group"
                                 aria-label="Select gradient type">
                              <input type="radio" class="btn-check" name="btnType" v-model="gradient.gradientType"
                                     id="btn-type-1" autocomplete="off"
                                     checked value="linear-gradient">
                              <label class="btn btn-primary-light ripple ripple-primary mx-0"
                                     for="btn-type-1">Linear</label>

                              <input type="radio" class="btn-check" name="btnType" v-model="gradient.gradientType"
                                     id="btn-type-2" autocomplete="off" value="radial-gradient">
                              <label class="btn btn-primary-light ripple ripple-primary mx-0"
                                     for="btn-type-2">Radial</label>
                            </div>
                          </div>
                        </div>
                        <!-- GRADIENT ROTATION -->
                        <div class="col-12 col-md-4 mb-3">
                          <div class="mb-3" v-if="(gradient.gradientType === 'linear-gradient')">
                            <label for="input-rotation" class="mb-2">Rotation</label>
                            <select v-model="gradient.gradientRotation" class="form-select form-control form-big-height"
                                    id="input-rotation"
                                    aria-label="Select rotation">
                              <option value="0" selected>0°</option>
                              <option value="45deg">45°</option>
                              <option value="90deg">90°</option>
                              <option value="135deg">135°</option>
                              <option value="180deg">180°</option>
                              <option value="225deg">225°</option>
                              <option value="270deg">270°</option>
                              <option value="315deg">315°</option>
                            </select>
                          </div>
                          <div class="mb-3" v-else>
                            <label for="input-rotation-radial" class="mb-2">Rotation</label>
                            <select v-model="gradient.gradientRotation" class="form-select form-control form-big-height"
                                    id="input-rotation-radial"
                                    aria-label="Select rotation">
                              <option value="closest-side" selected>Closest-side</option>
                              <option value="circle">Circle</option>
                              <option value="ellipse">Ellipse</option>
                            </select>
                          </div>
                        </div>
                        <!-- GRADIENT NAME -->
                        <div class="col-12 col-md-4 mb-3" v-if="user.loggedIn">
                          <div class="mb-3">
                            <label for="input-name" class="mb-2">Gradient name</label>
                            <input v-model="gradient.name" type="text" class="form-control form-big-height"
                                   id="input-name"
                                   placeholder="Ex. Fire Red, Leaf Green" required autocomplete="off"
                                   autofocus>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-footer no-border">
              <div class="row">
                <!-- GRADIENT BUTTON ACTIONS -->
                <div class="col-md-12 text-end">
                  <button class="btn btn-primary-light ripple ripple-dark" data-bs-toggle="modal"
                          data-bs-target="#cssModal">
                    <i class="material-icons-outlined">code</i>
                    Copy css
                  </button>
                  <button class="btn btn-primary-light ripple ripple-dark" @click="clearInputs">
                    <i class="material-icons-outlined">refresh</i>
                    Clear inputs
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BUTTONS ACTIONS -->
      <div class="row align-items-center">
        <div class="col-6 col-md-6">
          <button class="btn btn-fab m-0" @click="expandGradient"><i
              class="material-icons-outlined btn-fab-icon">{{ isExpanded ? 'close' : 'fullscreen' }}</i>
          </button>
          <button class="btn btn-fab btn-fab-download m-0" @click="downloadGradient"
                  :class="[ isExpanded ? 'd-block' : 'd-none']"><i
              class="material-icons-outlined btn-fab-icon">download</i>
          </button>
        </div>
      </div>

      <!-- MODAL CSS -->
      <div class="modal fade" id="cssModal" tabindex="-1" aria-labelledby="cssModalLabel'" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <p class="modal-title typography-headline-md" id="cssModalLabel">CSS</p>
              <button type="button" class="btn-close img-logo" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="table-responsive">
                <table class="table table-hover table-borderless">
                  <thead>
                  <tr>
                    <th scope="col">Orientation</th>
                    <th scope="col">CSS (Click text to copy)</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="align-middle">
                    <th scope="row"><i
                        class="material-icons-outlined text-secondary mdc-18 me-2">rotate_90_degrees_ccw</i>
                      {{ gradient.gradientRotation }}
                    </th>
                    <td v-if="gradient.color3" class="text-lowercase">
                      <code class="selector-gradient text-underline">
                        background: {{ gradient.gradientType }}({{ gradient.gradientRotation }},
                        {{ gradient.color1 }}, {{ gradient.color2 }}, {{ gradient.color3 }});</code>
                    </td>
                    <td v-else class="text-lowercase">
                      <code class="selector-gradient text-underline">
                        background: {{ gradient.gradientType }}({{ gradient.gradientRotation }},
                        {{ gradient.color1 }}, {{ gradient.color2 }});</code>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-link" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- TABLE COLOR CONVERTER -->
      <div class="row">
        <div class="col-md-12">
          <div class="card card-overflow shadow-0dp">
            <TableGradientColors :gradient="gradient"></TableGradientColors>
          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import TableGradientColors from "@/components/gradients/TableGradientColors";
import {mapGetters} from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
import VueAos from 'vue-aos'
import * as htmlToImage from 'html-to-image';

export default {
  name: 'GradientGenerator',
  metaInfo: {
    title: 'Gradient Generator',
  },
  components: {TableGradientColors, Footer, Navbar, VueAos},
  data() {
    return {
      gradient: {
        color1: '#ff0ab1',
        color2: '#e20aff',
        gradientType: 'linear-gradient',
        gradientRotation: '90deg',
        name: 'My gradient'
      },
      gradientUID: null,
      error: null,
      isExpanded: false
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.copyCodeCSS()
  },
  methods: {
    onSubmit() {
      const db = firebase.firestore()
      let color3 = this.gradient.color3

      if (color3) {
        const gradientUID = db.collection('users').doc(this.user.data.uid).collection('gradients').doc()
        gradientUID.set({
          name: this.gradient.name,
          color1: this.gradient.color1,
          color2: this.gradient.color2,
          color3: this.gradient.color3,
          gradientType: this.gradient.gradientType,
          gradientRotation: this.gradient.gradientRotation,
          createdAt: new Date(Date.now()).toLocaleString()
        })
        console.log(gradientUID, 'uid')
        this.$swal({
          customClass: {
            confirmButton: 'btn btn-primary btn-w-100',
          },
          buttonsStyling: false,

          showConfirmButton: true,
          icon: 'success',
          title: '3 colors gradient saved!',
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.replace("/profile")
          }
        }).catch(err => {
          this.error = err.message
        })
      } else {
        const gradientUID = db.collection('users').doc(this.user.data.uid).collection('gradients').doc()
        gradientUID.set({
          name: this.gradient.name,
          color1: this.gradient.color1,
          color2: this.gradient.color2,
          gradientType: this.gradient.gradientType,
          gradientRotation: this.gradient.gradientRotation,
          createdAt: new Date(Date.now()).toLocaleString()
        })
        console.log(gradientUID, 'uid')
        this.$swal({
          customClass: {
            confirmButton: 'btn btn-primary btn-w-100',
          },
          buttonsStyling: false,

          showConfirmButton: true,
          icon: 'success',
          title: '2 colors gradient saved!',
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.replace("/profile")
          }
        }).catch(err => {
          this.error = err.message
        })
      }
    },

    copyCodeCSS() {
      const aioCss = document.querySelectorAll('.selector-gradient')
      aioCss.forEach(codeCss => {
        codeCss.addEventListener('click', () => {
          const selectionCss = window.getSelection();
          const rangeCss = document.createRange();
          rangeCss.selectNodeContents(codeCss);
          selectionCss.removeAllRanges();
          selectionCss.addRange(rangeCss);

          try {
            document.execCommand('copy');
            selectionCss.removeAllRanges();

            const originalCss = codeCss.textContent;
            codeCss.textContent = 'CSS Code Copied!';
            codeCss.classList.add('text-success');
            this.$swal({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              icon: 'success',
              title: 'Code copied!',
            });

            setTimeout(() => {
              codeCss.textContent = originalCss;
              codeCss.classList.remove('text-success');
            }, 1200);
          } catch (e) {
            const errorMsgCss = document.querySelector('.error-msg');
            errorMsgCss.classList.add('d-block');

            setTimeout(() => {
              errorMsgCss.classList.remove('d-block');
            }, 1200);
          }
        });
      });
    },

    clearInputs() {
      this.gradient = {}
    },
    expandGradient() {
      this.isExpanded = !this.isExpanded
    },
    downloadGradient() {
      htmlToImage.toJpeg(document.getElementById('expanded-gradient'), {quality: 1})
          .then(function (dataUrl) {
            const link = document.createElement('a');
            link.download = 'my-gradient.jpeg';
            link.href = dataUrl
            link.click();
          })
    },
  }
}
</script>

<style scoped>
.gradient {
  transition: none !important;
}
</style>